var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiUpdateRfpOfferDraft } from '@/actions/rfpProOfferActions';
import { RfpProOfferPaymentView } from '@/components/pages/rfp/professional/RfpProOfferPaymentView';
import Layout from '@/container/Layout';
import { notify } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { updateRfpProOfferPaymentAction } from '@/pages/rfp/professional/offer/RfpProOfferRoot/RfpProOfferRootReducer';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { getIsPublic, getPublicPaymentDraftValues, getDirectPaymentDraftValues, } from '@/utils/resources/rfp/rfpProOfferSave';
import { professionalRfpOfferConfirmPath } from '@/utils/router/links';
const title = '支払情報を入力';
export const RfpProOfferPaymentPage = (props) => {
    const { changeStepValue, formDispatch, formValues, lockId, rfp } = props;
    const dispatch = useDispatch();
    const history = useNavigate();
    const formOfferValues = formValues.offer;
    const isPublic = getIsPublic(rfp.rfp_type, formOfferValues);
    /** 予算 */
    const price = useMemo(() => {
        var _a;
        const value = isPublic
            ? formOfferValues === null || formOfferValues === void 0 ? void 0 : formOfferValues.price
            : ((_a = formOfferValues === null || formOfferValues === void 0 ? void 0 : formOfferValues.max_price) !== null && _a !== void 0 ? _a : formOfferValues === null || formOfferValues === void 0 ? void 0 : formOfferValues.price);
        return typeof value === 'string' ? parseFloat(value) || undefined : value;
    }, [formOfferValues, isPublic]);
    /** paymentForm 初期値 */
    const initialValues = useMemo(() => ({
        payment: formValues.payment,
    }), [formValues]);
    /**
     * FormState 更新
     */
    const updateFormState = useCallback((paymentFormValues) => {
        formDispatch(updateRfpProOfferPaymentAction(paymentFormValues.payment));
    }, [formDispatch]);
    /**
     * 下書き保存
     */
    const onSubmitDraft = useCallback((paymentFormValues) => __awaiter(void 0, void 0, void 0, function* () {
        const data = {
            json: isPublic
                ? getPublicPaymentDraftValues(paymentFormValues, Object.assign(Object.assign({}, formValues), { offer: formOfferValues }))
                : getDirectPaymentDraftValues(paymentFormValues, Object.assign(Object.assign({}, formValues), { offer: formOfferValues })),
            path: { id: rfp.id, lock_id: lockId },
        };
        yield wrapDispatch(dispatch, apiUpdateRfpOfferDraft(data, {}));
    }), [dispatch, formValues, formOfferValues, isPublic, lockId, rfp]);
    /**
     * onSubmit
     */
    const onSubmit = useCallback((paymentFormValues) => __awaiter(void 0, void 0, void 0, function* () {
        // 下書き保存
        if (paymentFormValues.is_draft) {
            changeStepValue({ payment: false });
            yield onSubmitDraft(paymentFormValues);
            notify('下書きに保存しました');
            return;
        }
        // form 値更新
        updateFormState(paymentFormValues);
        // 確認ページに遷移
        changeStepValue({ payment: true });
        history.push(professionalRfpOfferConfirmPath(rfp.id), {
            state: { lockId },
        });
    }), [changeStepValue, history, lockId, onSubmitDraft, rfp, updateFormState]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(RfpProOfferPaymentView, { budget: rfp.max_budget || rfp.budget, initialValues: initialValues, lockId: lockId, onSubmit: onSubmit, paymentOption: rfp.payment_option, paymentOptionViewable: rfp.payment_option_viewable, price: price, rfpId: rfp.id, rfpName: rfp.name, title: title, updateFormState: updateFormState })] })));
};
